import { createReducer } from '@reduxjs/toolkit';

import { ScheduleManager, Loadable } from 'models';
import { makeThunkFromAPICall } from 'state';

export type SchedulesState = {
    list: Loadable<ScheduleManager.Schedule[]>;
    scheduleStatusResponse: Loadable<ScheduleManager.Schedule>;
};

const initialState: SchedulesState = {
    list: { status: 'idle' },
    scheduleStatusResponse: { status: 'idle' },
};

export const [getScheduleList, setScheduleList] = makeThunkFromAPICall(
    ScheduleManager.listSchedules,
    'Schedules/list',
);

export const [getDetailedSchedules, setDetailedSchedules] =
    makeThunkFromAPICall(
        ScheduleManager.listSchedules,
        'Schedules/list-no-save',
    );

// Not Saved in Redux
export const [getSchedule, setSchedule] = makeThunkFromAPICall(
    ScheduleManager.getSchedule,
    'Schedules/get',
);

// Not Saved in Redux
export const [getScheduleSummeryList, setScheduleSummeryList] =
    makeThunkFromAPICall(
        ScheduleManager.listScheduleSummeries,
        'Schedules/summery-list',
    );

export const [sendUpdateScheduleStatus, setUpdateScheduleStatusResponse] =
    makeThunkFromAPICall(
        ScheduleManager.updateScheduleStatus,
        'Schedules/change-status',
    );

export const schedulesReducer = createReducer(initialState, (builder) => {
    builder.addCase(setScheduleList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });

    builder.addCase(setUpdateScheduleStatusResponse, (state, action) => {
        return {
            ...state,
            list: {
                ...state.list,
                object: state.list.object?.map((schedule) => {
                    if (schedule.id === action.payload.loadable.object?.id) {
                        return {
                            ...schedule,
                            status: action.payload.loadable.object.status,
                        };
                    }
                    return schedule;
                }),
            },
            scheduleStatusResponse: action.payload.loadable,
        };
    });
});

export const schedulesActions = {
    getScheduleList,
    setScheduleList,
    getSchedule,
    getDetailedSchedules,
    getScheduleSummeryList,
    setScheduleSummeryList,
    sendUpdateScheduleStatus,
};

export default schedulesReducer;
